import { IApplicationState } from '../../types/redux';

export function selectBlackFridayPromoDatesText(state: IApplicationState) {
  return state.blackFriday.promoDatesText;
}
